module.exports = __webpack_public_path__ + "img/inativosrecentes.21fedb73.png";